import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { motion } from 'framer-motion';
import type React from 'react';

import { palette } from '../../assets/styles/themes/tokens';

// Kept under the sidebar wrappers' 8px side padding so the halo never reaches
// the drawer menu list, the one clipping ancestor in play.
const SPREAD_PX = 8;
const EXPAND_S = 1.1;
const REST_S = 0.7;
// framer-motion counts repeats after the first play, so 2 means three pulses.
// They end at 4.7s, inside the hook's 5s window, so the ring stops itself
// instead of relying on being unmounted (WCAG 2.2.2 — no indefinite motion).
const REPEATS = 2;

const ringStyles = {
	position: 'absolute',
	inset: 0,
	borderRadius: 'inherit',
	pointerEvents: 'none',
};

/**
 * Expanding ring halo that draws the eye to the sidebar report card. Grows as a
 * box-shadow spread rather than a `scale`, so the halo thickens by the same
 * number of pixels all round on both the wide card and the square badge —
 * scaling a 200×50 box would stretch it sideways.
 */
const PulseRing: React.FC = () => (
	<Box
		component={motion.span}
		data-testid="trial-report-card-pulse"
		aria-hidden="true"
		sx={ringStyles}
		initial={{ boxShadow: `0 0 0 0 ${alpha(palette.primary.main, 0.45)}` }}
		animate={{ boxShadow: `0 0 0 ${SPREAD_PX}px ${alpha(palette.primary.main, 0)}` }}
		transition={{
			duration: EXPAND_S,
			ease: 'easeOut',
			repeat: REPEATS,
			repeatDelay: REST_S,
		}}
	/>
);

export default PulseRing;
